import { Divider, Layout, Typography, theme } from "antd";
import "./PatchNotes.css";

const { Content } = Layout;
const { Paragraph, Text, Title } = Typography;

const patchNotes = [
  {
    version: "0.5.9",
    type: "minor",
    title: "New player experience rework",
    date: "Coming soon ! <3",
    summary: "User testing has shown that the current new player experience is not good enough. Players struggle to quickly understand the game and it's core systems. The rework focuses on improving understanding of the game and improving the experience during both the first 5 minutes and the first hour. ",
    sections: [
      {
        title: "Features:",
        changes: [
          "The tutorial before selecting the starter company has been removed.",
          "The starter company view has been reworked and is now the initial introduction to the game",
          "After selecting a company, the user will go through a short tutorial which makes the user hire employees, set up production and make a sale instantly with time skipping. (Hiring employees and waiting an hour before you could see any progress used to be one of the major pain-point)",
          "After completing the tutorial, the entire game opens up and beginner clues will be active on many pages until the starter challenges have been completed.",
        ],
      },
    ],
  },
  {
    version: "0.5.8",
    type: "minor",
    title: "Next patch",
    date: "07-11-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: [
          "",
        ],
      },
      {
        title: "Changes:",
        changes: [
          ""
        ],
      },
      {
        title: "Fixes:",
        changes: [
          "",
        ],
      },
    ],
  },
  {
    version: "0.5.7",
    type: "minor",
    title: "Demand and supply rework",
    date: "05-11-2026",
    summary: "The old calculations resolving competition over inhabitant demand was not cutting it. The new system more fairly distributes demand. Also added a dedicated view which makes it much easier to understand how much supply and demand there is in a tile and why you're selling a certain amount at a certain price.",
    sections: [
      {
        title: "Features:",
        changes: [
          "Every cycle, for each product and tile, inhabitant demand is spread across nine price brackets ranging from 0.5x to 1.5x the normal price. Normal price reflects buying power, satisfaction and monthly demand events.",
          "Each realestate sets a minimum sell price. Demand is distributed from the highest price bracket down. Every eligible realestate receives an equal share, capped by remaining supply, with unused shares redistributed equally.",
          "Added a supply and demand view where you can get a better understanding of what's going on in the market.",
          "Added a minimizable pricing panel above the production queue where you can set minimum price and view supply and demand. Removed the old sell price button.",
        ],
      },
      {
        title: "Changes:",
        changes: [
          "New sell instructions now default to base price.",
          "Increased base demand per thousand to 50 for product item that had less than 50."
        ],
      },
      {
        title: "Fixes:",
        changes: [
          "Fixed a bug where the footer would not become smaller when side-nav was hidden.",
        ],
      },
    ],
  },
  {
    version: "0.5.6",
    type: "minor",
    title: "More user testing",
    date: "02-11-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: [
          "For transportation between your own realestates, you can now use any of your realestates as a transporter instead of just the sender or receiver.",
          "Improved the on-hover card for realestates, sites, facilities, jobs, items and employees to show more information than just the name.",
          "Starter challenge: Write a message in the global chat",
          "The Map now shows where there the other companies are on the map and which realestate types they have in the different tiles. You can click a company's name from the tile details to enter their profile.", 
          "Profile page now shows which tile the different realestates are in and lets you click it to jump to that tile on the map.",
          "On startup, the game will now attempt to recover lost cycles.",
          "Employees that were away for parts of the cycle have that time subtracted from their contribution to production.",
          "Added an on-hover employee breakdown which gives you a quick overview of what your employees are doing and how many will be available for production in the next cycle.",
        ],
      },
      {
        title: "Changes:",
        changes: [
          "Changed the algorithm for population growth. The previous one was more delayed than intended.",
          "You can now see the route that your transport will take along with timings and distances per step.",
          "Reworked the active deliveries view to more clearly show the behaviour of ongoing transports.",
          "You can now bring the employee target quantity above capacity.",
          "Salary achievement bonus now shows on employees page.",
          "Changed it so employees commited to a pending market order can still perform production work.",
          "Achievement: 'Its not rocket science' is now only given to the first company to discover a science.",
          "Networth used to only count balance + storage items. Now it should give a full picture with: balance + storage items + realestate sqm + facilities - debt. Takes ongoing transports and construction work into consideration. Also increased the requirements for the Too big to fail achievement.",
          "Reworked the New/Expand/Sell realestate modal. Sqm input is now on the top and the tile picker dropdown has been reworked to be searchable and have a scrollbar.",
          "Redesigned the encyclopedia to be less cluttered and easier to understand on 1080p monitors and less.",
          "The construction work progress bar now shows ongoing work.",
          "Send construction work button disabled when no more construction work can be sent to that construction project.",
          "You can now see the travel distance and time before dedicating to character movement.",
          "You now get an event notification when someone accepts your market order.",
          "For windows with small width, added the option to show/hide the side-nav + logo for more available space.",
        ],
      },
      {
        title: "Fixes:",
        changes: [
          "Fixed a bug on the daily report page where the on-hover card for the storage graph had some weird behaviour when hitting the edge of the window.",
          "Fixed a bug where buying realestate sqm didn't record a transaction for the activities page.",
          "Fixed a bug where new seasons would start with factors at 50% instead of 0%.",
          "Fixed a bug where the map population layer would start at minimum 25, not 100.",
          "Fixed a bug where employee salary could get stuck in an infinite loop of rising instead of stabilizing because it got reinforced by itself every cycle.",
          "Fixed a bug where employees would stay after deleting your basic workplaces as long as you didn't reduce target quantity."
        ],
      },
    ],
  },
  {
    version: "0.5.5",
    type: "minor",
    title: "Preparing for playtest",
    date: "28-10-2026",
    summary: "This patch starts the first official season: Alpha 1. Moving forward the game and accounts will no longer be reset with every major patch. The game should now stay persistent and i will do my best to only release breaking changes between seasons. There will still be balance patches, bugfixes and minor releases during the seasons.",
    sections: [
      {
        title: "Features:",
        changes: [
          "More pages now refresh their data live when it updates on the server side.",
          "Sites are now editable. You can expand or deconstruct parts of an existing site by adding further construction projects to it. Maximum one active construction project per site. You can continue to use the site and its existing facilities while an expansion project is ongoing. Deconstructing a site reclaims 50% of the build cost to storage.",
          "Daily report: Instead of grouping each type of data together and showing each realestate in that section, we now group data on realestate and show each type of data in that section",
          "Daily report: Added information about currently active outgoing and incoming transports per realestate",
          "Daily report: Added a storage history graph per realestate which shows how full your storage was at the end of each cycle. Includes different colors for reserved storage and reserved items, similar to the capacity bar in the storage view.",
          "Daily report: When hovering over each production square, show production success and failure reasons in order to figure out which requirements were lacking.",
          "Removed the ability to quick-sell items from your storage.",
          "Added the ability to delete items from your storage.",
          "Added a timer in the header counting down untill the next hourly cycle.",
          "Added red notification icon for new earned achievements untill user looks at the Activities page. Previously unread eventlogs are marked with a 'new' tag on them.",
          "Added new tile modifier in the map tile details view: Movement"
        ],
      },
      {
        title: "Changes:",
        changes: [
          "Season max timer set to 1 month for now. Wonder requirements are also greatly decreased. As we get closer to 1.0 the seasons will become longer until we find a sweetspot - Perhaps somewhere between 3-12 months.",
          "Factors page: Overview now only show a select few useful factors. All factors still show in detailed tree-view.",
          "Balanced all item base values.",
          "Made the sheep-related jobs stronger as they were inherently underpowered compared to the competing horse and cotton-related jobs.",
          "Market page: Changed confusing wording in the transporter column when looking at your own market orders.",
          "Stone weight lowered from 5 to 4.",
          "In-tile transportation distance halved.",
          "Between-tile transportation distance algorithm changed slightly.",
          "Increased base population from 25 to 100.",
          "Increased wood demand by 50%.",
          "Increased stone demand by 50%.",
          "Reduced how quickly realestate modifier for land price scales.",
          "Eventlogs for achievements now show an achievement icon instead of a warning icon.",
          "Decreased the amount of supply science types from one per supply output to one per store type.",
          "Achievements 'The factory must grow', 'No refunds' and 'Payday' had their requirement costs increased by x10. 'Eureka' had its requirement cost increased by x100.",
          "The game now remembers whether you have minimized the global chat and starter challenges."
        ],
      },
      {
        title: "Fixes:",
        changes: [
          "Fixed a bug where supply types was listed in the dropdown for the producer leaderboard.",
          "Fixed a bug where the map could show more population than the workers in the tile would add up to in the employees page.",
          "Fixed a bug where storage facilities under construction in some cases could contribute to the storage capacity.",
          "Fixed a bug where character gathering tasks did not respect the storage capacity"
        ],
      },
    ],
  },
  {
    version: "0.5.4",
    type: "minor",
    title: "User testing",
    date: "24-10-2026",
    summary: "",
    sections: [
      {
        title: "Content:",
        changes: [
          "Character task: Gather water"
        ],
      },
      {
        title: "Changes:",
        changes: [
          "Added 4 steps to the tutorial without increasing the scope.",
          "Changed some of the tutorial texts and bolded game definitions.",
          "Changed the starter company view to more clearly guide new users through the 4-step-process.",
          "Changed the result view in in the create transport modal to show used/total employees instead of just used. For example 2/4 employees",
          "Given names default to typename instead of generic hardcoding. For example jobs default to 'Cut wood' instead of 'New job'.",
          "Removed residential store site, residential checkout facility and commercial checkout facility as they had no actual use case."
        ],
      },
      {
        title: "Fixes:",
        changes: [
          "Fixed a bug where the event and world wonder leaderboards would show incorrect point rewards.",
          "Fixed a bug where rounding error in some cases caused the job rows and the production overview to show numbers inconsistent with eachother.",
          "Fixed a bug where the employment page would display employment rate incorrectly."
        ],
      },
    ],
  },
  {
    version: "0.5.3",
    type: "minor",
    title: "Achievements v2",
    date: "23-10-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: [
          "Added 16 achievements. Some of them have multiple levels that get exponentially harder",
          "Achievements award achievement points",
          "Achievement points can be spent for unlocking upgrades: realestate cap, site cap, production output, lowered salary, active science, transport speed and construction speed"
        ]
      },
      {
        title: "Changes:",
        changes: [
          "Renamed the previous starter achievements to starter challenges and refactored some of their completion criteria slightly",
          "Achievement page now has three tabs: Achievements, Unlocks and Starter challenges",
          "Base realestate capacity is now 3 and base site capacity is now 6"
        ],
      },
    ],
  },
  {
    version: "0.5.2",
    type: "minor",
    title: "Tutorial",
    date: "21-10-2026",
    summary: "Quick tutorial guiding new players through base concepts in a singleplayer world where they control time before selecting a starter company for the real game",
    sections: [
      {
        title: "Features:",
        changes: [
          "2 minute skippable tutorial",
        ],
      },
    ],
  },
  {
    version: "0.5.1",
    type: "minor",
    title: "Starter company",
    date: "19-10-2026",
    summary: "Players can now choose between different starter companies and select where on the map each realestate should spawn.",
    sections: [
      {
        title: "Features:",
        changes: [
          "Special view where you can only access a few pages (Season, Map, Encyclopedia, Wiki) to get information about the world untill you have created your company.",
          "Choose a starter company type: Extraction or Farming.",
          "Choose location of realestates",
          "Choose a company name"
        ],
      },
    ],
  },
  {
    version: "0.5.0",
    type: "major",
    title: "Seasons",
    date: "17-10-2026",
    summary: "Added a wipe mechanic. This feels like the right choice for a game with intentional inflation and game-wide technology progression. Every season a large world wonder project exists somewhere on the map. Any player can contribute to the project and when it finishes the season ends and a new begins. Win the season by scoring the most season points. When a season ends, companies get a factory reset.",
    sections: [
      {
        title: "Features:",
        changes: [
          "Season page + wiki section",
          "A season ends when the season timer runs out or when the world wonder is completed.",
          "Companies can earn season points by contributing to the world wonder.",
          "Companies can earn season points by contributing to a monthly event somewhere on the map.",
          "Companies can earn season points by contributing to a weekly event somewhere on the map.",
          "Season points leaderboard.",
          "Season points displayed on profile.",
          "Event icons on the map show world wonder, monthly event and weekly event location. Also shows location of next monthly event and next weekly event."
        ],
      },
      {
        title: "Changes:",
        changes: [
          "Reworked retail. Having the Retail realestate be the only realestate allowed to run sell jobs was too restrictive. Each realestate can now build a limited store that allows selling the products related to that realestate. The Retail realestate still exists and can sell all items.",
          "Removed Builder realestate and all associated content - It served no meaningful purpose in the current state of the game.",
          "Combined realestates Bakery, Flour maker, Slaughterhouse, Brewery and fishing industry into a single Food & Beverages realestate",
          "Combined realestates Textile mill, Garment factory and Tannery into a single Textile realestate",
          "Reworked the the factors responsible for dynamic changes to a tile's population behaviour.",
          "Construction work now has a 24h max limit to travel time + work time. After returning it can instantly be sent back out again.",
          "When calculating how much quantity of an item the population wants to buy, fractions are now taken into account. For example: 2.3 → 2 units, with a 30% chance of a third."
        ],
      },
      {
        title: "Fixes:",
        changes: [
          "Fixed a bug where in some cases, companies would not sell as much supply as they should have.",
        ],
      },
    ],
  },
  {
    version: "0.4.0",
    type: "major",
    title: "Science",
    date: "11-10-2026",
    summary: "Unlock increased efficiency and new opportunities",
    sections: [
      {
        title: "Features:",
        changes: ["Science page + wiki section", "Science can be earned by completing jobs, consuming science books or through a character task.", "Science levels in specific items give increased production.", "Science levels in industries will in the future be able to unlock new sites, facilities, jobs and items.", "Each company that have discovered a science make it easier for other companies to also discover the same science."],
      },
      {
        title: "Content:",
        changes: ["Site: Science department",
          "Facility: Research lab",
          "Jobs: Jobs to create each science book type",
          "Item: One science book for each industry (real estate type)"
        ],
      },
    ],
  },
  {
    version: "0.3.8",
    type: "minor",
    title: "User interface facelift",
    date: "06-10-2026",
    summary: "Iterating on in-game design. Updating several pages to be more intuitive and adding quality of life improvements.",
    sections: [
      {
        title: "Changes:",
        changes: [
          "Landing page: Opening the landing page while logged in will redirect you to the logged-in view instead.",
          "Menus: Added a real estate icon next to the name on each  select real estate button.",
          "Error pages: Updated the design of the 404 page. Invalid URLs now show a 404 page, while loading failures show a new 'Unable to load page' error page with a retry option.",
          "Verify email and Forgot password pages: Updated the design. Added a reminder to check your spam folder.",
          "Profile page: The company name in the header changes instantly when renamed. Added links from rank and leaderboard medals to relevant leaderboards. Added a link from achievements to the achievements page.",
          "Daily report page: Failed data loading no longer incorrectly shows a 'No data available' message. It now shows an error and a retry option.",
          "Character page: Now says 'Move to <real estate name>' instead of 'Move here'. If the character is already at the selected real estate, it says 'Your character is at <real estate name>' instead of 'Your character is here'.",
          "Messages page: Shows a 'New messages' button if you receive a message in a chat while scrolled up. Improved error handling.",
          "Achievements page: Page now refreshes if you receive an achievement while on the page.",
          "Leaderboards page: Added a description for each metric, explaining whether it is a snapshot of the last cycle or a value accumulated over time. Added a tooltip explaining how ties work in the leaderboards.",
          "Settings page: Shows an indicator when a changed setting is successfully saved. Better error handling.",
          "Overview page: Reworked the design of the site cards. Renamed Property value to Land value.",
          "Storage page: Added 'none' placeholder for empty reserved sections. Replaced hover-effects on the capacity bar with a legend above the bar showing storage values at all times. Improved visuals during loading.",
          "Production page: New jobs now default to a target of 1 instead of 0. It is no longer possible to enter decimal values in the frontend target input. Names are now shown next to icons in the production overview on the right.",
          "Employees page: Saving a value no longer refreshes the entire page or discards other unsaved changes. The maximum salary input now accepts decimal values. Added a saved indicator for success feedback.",
          "Market page: Improved error handling. The confirmation button for accepting market orders is disabled until valid input is provided.",
          "Activity page: Performance improvements in the backend when fetching events.",
          "Map page: Selecting a tile and map layer updates the URL, making the selection shareable with other players. Added an icon for each real estate you own. Included a switch to toggle between icons and old real estate count. The map tile count no longer includes sea and ocean tiles.",
          "Encyclopedia page: Added a search bar to quickly find entries. Switched from an on-hover popup detailed view to a click-to-open static detailed view. Removed supply items, maintained livestock items and construction work items from entries. Sorted entries alphabetically.",
          "Factors page: Changed the factors to always show tile-specific values. Default tile is the tile of your selected real estate. Added a dropdown to inspect other tiles. Values refresh when a cycle completes. Added an on-hover tooltip explaining the change during the last cycle.",
          "Statistics page: Added a search bar to the different dropdowns so you can search instead of scrolling through long lists. The search button is disabled until valid input is provided.",
          "Wiki page: References to other pages in the wiki text are now clickable links. For some sections, added a 'Requirements' section explaining the rules of that feature. Added an illustration explaining the relationship between real estates, sites and facilities.",
          "Legal page: Fixed a typo in the privacy policy and rewrote the icon credits section to be more informative."
        ],
      },
      {
        title: "Fixes:",
        changes: [
          "Profile page: Fixed a bug where the profile page would briefly show your company name when loading other players' profiles.",
          "Settings page: Fixed a bug where the layout of the Settings page would differ from the rest of the game.",
          "Overview page: Fixed a bug where the price for a new real estate could sometimes be displayed incorrectly in the frontend. Fixed a bug where sites sometimes could not be deleted right after being constructed. Fixed a bug where the frontend for the 'Sell area' modal could sometimes indicate an invalid range of sellable land.",
          "Production page: Fixed a bug where changing job queue priority could yield unexpected priority behaviour.",
          "Market page: Fixed a bug where switching between real estates while on the market page could in some cases show stale data.",
          "Activity page: Fixed a bug in the aggregated transaction view where cycles without any transactions would not show a row.",
        ],
      },
    ],
  },
  {
    version: "0.3.7",
    type: "minor",
    title: "New landing page",
    date: "02-10-2026",
    summary: "New design for the login page and links to the 'About the game' and 'Patch notes' pages that can be accessed without logging in.",
    sections: [
      {
        title: "Features:",
        changes: ["About the game page", "Existing patch notes page made available without logging in"],
      },
      {
        title: "Changes:",
        changes: ["Login page redesigned", "SEO improvements"],
      },
    ],
  },
  {
    version: "0.3.6",
    type: "minor",
    title: "Wiki",
    date: "29-09-2026",
    summary: "Wiki explaining different topics in the game. Relevant topics are linked to from tooltips around the game.",
    sections: [
      {
        title: "Features:",
        changes: ["Wiki page", "Links to relevant wiki sections from various pages"],
      },
    ],
  },
  {
    version: "0.3.5",
    type: "minor",
    title: "Technical debt",
    date: "27-09-2026",
    summary: "Technical cleanup, maintenance, updates and security improvements.",
    sections: [],
  },
  {
    version: "0.3.4",
    type: "minor",
    title: "Player market",
    date: "10-09-2026",
    summary: "Buy and sell items to other players in the market. Transportation costs based on distance are factored into the total price.",
    sections: [
      {
        title: "Features:",
        changes: ["Market page", "Items and construction work can be bought and sold through buy and sell orders", "Listed orders reserve money, items, employees and/or storage space in order to guarantee that the order will go through if someone accepts it", "If the order specifies that the lister is responsible for transportation, and the lister is currently transporting items from that order to someone else, you can still order the remaining items, but your order will be queued until the existing transportation work is finished."],
      },
    ],
  },
  {
    version: "0.3.3",
    type: "minor",
    title: "Personal messages",
    date: "24-08-2026",
    summary: "Unlike the global chat, personal messages are one-to-one and persistent",
    sections: [
      {
        title: "Features:",
        changes: ["Messages page", "Notification for unread messages", "Block player (only affects personal messages)"],
      },
    ],
  },
  {
    version: "0.3.2",
    type: "minor",
    title: "Daily report",
    date: "23-08-2026",
    summary: "Quickly get an overview of what's been happening in your company during the last 50 hours",
    sections: [
      {
        title: "Features:",
        changes: ["Daily report page", "Balance, Net worth and Rank graphs", "Production report per real estate", "Employees gained/lost and salary per real estate"],
      },
    ],
  },
  {
    version: "0.3.1",
    type: "minor",
    title: "Fish and Bricks",
    date: "22-08-2026",
    summary: "Resources to complement the new map biomes",
    sections: [
      {
        title: "Content:",
        changes: ["Real estates: Fishing industry, Smelting industry", "Sites: Fishery, Clay extraction, Glassworks, Ceramic works, Brickworks", "Facilities: Fishing hut, Clay pit, Glass furnace, Ceramics kiln, Brick kiln", "Jobs: Fishing hut, Clay pit, Glass furnace, Ceramics kiln, Brick kiln, Sell fish, Sell clay, Sell glass, Sell ceramics, Sell bricks", "Items: Fish, Clay, Bricks, Ceramics, Sand, Glass", "Construction materials: Clay, Bricks", "Character task: Gather clay"],
      },
    ],
  },
  {
    version: "0.3.0",
    type: "major",
    title: "World Map",
    date: "20-08-2026",
    summary: "World map consisting of multiple tiles. Each tile has its own inhabitant population with its own satisfaction levels. The idea is that different tiles have different features and geographical locations, adding a tactical element to where players want to set up their business.",
    sections: [
      {
        title: "Features:",
        changes: ["Multiple tiles", "World map page", "Tiles now belong to a biome and have different modifiers", "Map filters: Terrain, Population size, Resources, Demand satisfaction", "Tile overview with more details when hovering/clicking on a tile in the map", "Biomes: Plains, Forest, Hills, Mountain, Desert, Wetlands, Fresh Water, Sea"],
      },
      {
        title: "Changes:",
        changes: ["Reworked Production view and New Job modal"],
      },
    ],
  },
  {
    version: "0.2.3",
    type: "minor",
    title: "Name and Chat filter",
    date: "14-08-2026",
    summary: "Consistent naming rules. Blacklist dictionary for weeding out names and chat messages. Profanity filter can be toggled in settings",
    sections: [
      {
        title: "Features:",
        changes: ["Blacklisted terms dictionary", "Messages with illegal terms are rejected", "Profanity filter setting: Words marked as profanity get blurred", "Username naming rules: 3-18 characters. a-z, A-Z, 0-9. Illegal terms and profanity filter", "Given name naming rules: 3-18 characters. a-z, 0-9, ' ', '-', '''. Illegal terms and profanity filter. First letter capitalized in each word", "Chat rate limiting", "REST request rate limiting"],
      },
    ],
  },
  {
    version: "0.2.2",
    type: "minor",
    title: "Terms of Service and Privacy Policy",
    date: "12-08-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: ["Legal page", "Terms of Service", "Privacy Policy"],
      },
    ],
  },
  {
    version: "0.2.1",
    type: "minor",
    title: "Footer",
    date: "10-08-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: ["Barebones official Discord server", "Footer with copyright notice, official Discord link and icon credits"],
      },
    ],
  },
  {
    version: "0.2.0",
    type: "major",
    title: "Healthcare and Education",
    date: "09-08-2026",
    summary: "Build schools to increase the education level of the population, over time creating skilled workers and specialists. Build hospitals and sell medicine in order to provide healthcare to the population.",
    sections: [
      {
        title: "Features:",
        changes: ["Skilled workers and specialists can now appear in the population if the education level is high enough", "Healthcare satisfaction and Education satisfaction now affect overall population satisfaction", "Real estates: Healthcare industry, Education industry, Paperworks", "Sites: Hospital, School, Apothecary, Paper mill, Book writer", "Facilities: Herb farm, Medical lab, Patient room, Fiber beater, Drying room, Writing desk, Classroom", "Items: Herbs, Medicine, Bandage, Wood fiber, Paper, Book", "Jobs: Cultivate herbs, Treat patient, Prepare medicine, Make bandage, Papermaking, Write book, Teach students"],
      },
    ],
  },
  {
    version: "0.1.10",
    type: "minor",
    title: "Test environment",
    date: "06-08-2026",
    summary: "Test new features, trigger bugs and implement breaking changes without affecting the players",
    sections: [
      {
        title: "Features:",
        changes: ["Test environment up and running at https://test.ageofcompanies.com. Updates will be deployed and tested here before releasing", "Only users with test access can log in to the test environment", "The test environment has a button to trigger the next world cycle instantly", "Admins can spawn preset companies in the test environment", "Admins can now copy the production environment data into the test environment. This should make it easier to recreate bugs discovered in production. It should also help with getting more realistic test data for testing new features."],
      },
    ],
  },
  {
    version: "0.1.9",
    type: "minor",
    title: "Admin functionality",
    date: "05-08-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: ["Admins can now log in as any user without a password to see all in-game views from their perspective. This should make it easier to help answer questions or understand bugs.", "Admins can now both inspect and delete the in-memory server cache", "Admins can now trigger system announcements to appear just below the header.", "Admins can now ban users"],
      },
    ],
  },
  {
    version: "0.1.8",
    type: "minor",
    title: "Debt and repayment",
    date: "04-08-2026",
    summary: "Discovered an exploit where it was possible to get rid of employees that were on transportation or construction missions, in effect gaining the benefits of the employees without paying them. It's no longer possible to let go of committed employees. If your company does not have enough money to pay committed employees, debt will now accrue for each missed payment. The committed employees will immediately leave when the ongoing work is completed. Companies cannot hire any employees while in debt. Currently the only way to gain money in order to repay your debt is to sell all or parts of your real estate properties which can now be sold at 50% of buying price. Might add a feature for taking a loan in the future, which would make the debt mechanic less brutal.",
    sections: [
      {
        title: "Features:",
        changes: ["Unused real estate sqm can be sold at 50% of buying price (Used real estate sqm can be freed up by deleting sites)", "Employees on transport or construction missions can't leave the company", "Committed employees will instantly leave the company after completing their current activity if the company is in debt", "Companies unable to pay wages for committed employees will accrue debt. (Non-committed employees instantly leave when not paid)", "Debt can be paid off with money", "No employees will join your company while in debt"],
      },
      {
        title: "Fixes:",
        changes: ["Real estates can no longer be fully sold or deleted while they have ongoing construction work or transports.", "Individual sites can no longer be deleted if the deletion would cause storage to overflow. (An entire real estate can be deleted, but the items in storage are then deleted as well)", "Real estates that the character is traveling away from can now be deleted"],
      },
    ],
  },
  {
    version: "0.1.7",
    type: "minor",
    title: "Character",
    date: "03-08-2026",
    summary: "Control your character. It can perform various tasks and move between your real estates depending on your needs",
    sections: [
      {
        title: "Features:",
        changes: ["Character view", "Character movement between real estates", "Character can be set to perform a task"],
      },
      {
        title: "Content:",
        changes: ["Character task: Work", "Character task: Gather wood", "Character task: Gather stone"],
      },
    ],
  },
  {
    version: "0.1.6",
    type: "minor",
    title: "Password recovery",
    date: "02-08-2026",
    summary: "'Forgot password' button on the login page. A new password is sent by email, so email verification is necessary upon registration.",
    sections: [
      {
        title: "Features:",
        changes: ["Forgot password button", "Email verification upon registering", "Previously grayed out change password button implemented and clickable"],
      },
    ],
  },
  {
    version: "0.1.5",
    type: "minor",
    title: "Profile page",
    date: "01-08-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: ["Profile view with basic company information, custom description and leaderboard medals", "Clicking on other players opens their profile", "Clicking on your profile image or name in the header takes you to your profile", "Change company name functionality", "When global chat is minimized, a red notification counter shows if there are new messages", "Added a scrollbar to the roadmap timeline and auto-focus on the card currently being implemented"],
      },
    ],
  },
  {
    version: "0.1.4",
    type: "minor",
    title: "Leaderboards",
    date: "31-07-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: ["Leaderboards view", "Leaderboard stats refresh a few seconds after each cycle", "The current world cycle now shows in the top right corner"],
      },
    ],
  },
  {
    version: "0.1.3",
    type: "minor",
    title: "Refresh token",
    date: "30-07-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: ["Refresh token functionality. If the user is active, then the login session will stay active instead of getting logged out while playing"],
      },
      {
        title: "Fixes:",
        changes: ["Fixed a performance issue where opening the event view could in some cases trigger an unnecessary number of SQL queries"],
      },
    ],
  },
  {
    version: "0.1.2",
    type: "minor",
    title: "Achievements v1",
    date: "30-07-2026",
    summary: "The first iteration of the achievement system introduces a few basic starter achievements. The starter achievements yield useful rewards and are visible in a card until the player has completed them. The intention is to encourage new players to explore basic game mechanics",
    sections: [
      {
        title: "Features:",
        changes: ["Achievements view", "Achievement rewards", "Starter achievement card for new players"],
      },
      {
        title: "Content:",
        changes: ["Achievement: Visit the encyclopedia", "Achievement: Hire 3 unskilled workers", "Achievement: Produce 3 items in a single cycle", "Achievement: Send an item from one real estate to another", "Achievement: Sell an item to the local inhabitants", "Achievement: Construct a new site on one of your real estates", "Achievement: Buy a new real estate"],
      },
    ],
  },
  {
    version: "0.1.1",
    type: "minor",
    title: "Patch notes",
    date: "29-07-2026",
    summary: "",
    sections: [
      {
        title: "Features:",
        changes: ["Added this patch notes page"],
      },
    ],
  },
  {
    version: "0.1.0",
    type: "major",
    title: "Core gameplay loop",
    date: "29-07-2026",
    summary: "The first version of the game is up and running! 🎉 The core gameplay loop is implemented, the first batch of content is in place and all known bugs are fixed.",
    sections: [
      {
        title: "Features:",
        changes: ["Landing page with login and register functionality", "Header and sidebar visible from every logged-in view", "Events view and logic", "Transactions view and logic", "Real estate overview and logic", "Production view and logic", "Storage view and logic", "Employee view and logic", "Construction view and logic", "Transportation view and logic", "Early version of factors view", "Early version of statistics view", "Encyclopedia view", "Roadmap view", "Inhabitant population size dynamically adjusted based on overall satisfaction", "Inhabitant buying power dynamically adjusted based on wages and employment rate", "Inhabitant demand dynamically adjusted based on supply from companies", "Global chat", "Generic error handling with error message popup in the frontend"],
      },
      {
        title: "Content:",
        changes: ["Real estates: Wood industry, Stone industry, Workshop, Farmland, Water industry, Builder, Flour maker, Bakery, Brewery, Slaughterhouse, Tannery, Textile mill, Garments factory, Housing, Retail", "Sites: Storage, Woodcutter, Sawmill, Stonecutter, Stonemason, Workstations, Field, Water collection, Construction HUB, Windmill area, Kitchen, Brewing room, Livestock storage, Livestock processing, Tanning site, Textile processing, Garment creation, Apartment complex, Store", "Facilities: Basic workplace, Outside storage, Storage room, Basic shelter, Stationary saw, Quarry, Cutting bench, Tooling station, Furniture station, Grain farm, Hay farm, Cotton farm, Pasture, Well, Construction station, Contracting center, Windmill, Oven, Brewing system, Holding pen, Slaughter room, Tanning station, Spinning station, Weaving station, Sewing station, Basic apartment, Comfortable apartment, Checkout", "Jobs: Gather wood, Cut wood, Saw plank, Gather stone, Mine stone, Create basic tools, Create soft fabric, Create soft leather, Create hard furniture, Cultivate grain crops, Cultivate hay crops, Cultivate cotton crops, Catch wild horse, Breed horse, Maintain horse, Catch wild sheep, Breed sheep, Maintain sheep, Shear sheep, Draw water, Sell construction work, Grind grain, Bake bread, Brew beer, Maintain horse in holding pen, Maintain sheep in holding pen, Process horse, Process sheep, Create leather, Spin thread, Create fabric, Sew fabric clothing, Sew leather clothing, Rent out basic apartment, Rent out comfortable apartment, Sell bread, Sell meat, Sell beer, Sell clothing, Sell water, Sell soft furniture, Sell hard furniture, Sell wood, Sell plank, Sell stone, Sell stone block, Sell grain, Sell hay, Sell textile fibers, Sell horse, Sell sheep, Sell flour, Sell hide, Sell thread, Sell fabric, Sell leather, Sell basic tools", "Items: Wood, Plank, Stone, Stone block, Grain, Hay, Textile fibers, Horse, Sheep, Water, Flour, Bread, Beer, Meat, Hide, Thread, Fabric, Clothing, Leather, Basic tools, Soft furniture, Hard furniture"],
      },
    ],
  },
];

export default function PatchNotes() {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Layout className="patch-notes-layout">
      <Content className="patch-notes-content" style={{ background: colorBgContainer, borderRadius: borderRadiusLG }}>
        <header className="patch-notes-header">
          <Title>Patch Notes</Title>
        </header>

        <div className="patch-notes-list">
          {patchNotes.map((release) => (
            <article key={release.version} className={`patch-notes-release patch-notes-release-${release.type}`}>
              <Text type="secondary" className="patch-notes-date">
                {release.date}
              </Text>
              <Title level={2}>
                {release.version} — {release.title}
              </Title>
              <Paragraph className="patch-notes-summary">{release.summary}</Paragraph>

              <div className="patch-notes-sections">
                {release.sections.map((section) => (
                  <section key={section.title}>
                    <Title level={3}>{section.title}</Title>
                    <ul>
                      {section.changes.map((change) => (
                        <li key={change}>{change}</li>
                      ))}
                    </ul>
                  </section>
                ))}
              </div>
              <Divider className="patch-notes-release-divider" />
            </article>
          ))}
        </div>
      </Content>
    </Layout>
  );
}
